









import { Component, Vue, Prop, Model } from "vue-property-decorator";

@Component
export default class Textarea extends Vue {
  @Model("input") readonly value!: any;
  @Prop({ default: "" }) readonly placeholder?: string;
}
